import {curCoreClient, DeviceCommandParams, DownlinkItem} from "@/services/CoreClient";
import {Device} from "@/types/core";
import _ from "lodash";

export class GroupService {
  public async loadGroupConfiguration(query: GroupConfigurationQuery): Promise<GroupConfigurationParameter[] | Error> {
    const reply = await curCoreClient.loadGroupConfiguration(query);
    if(reply.errorMsg) {
      return Promise.reject(new Error(`Cannot load group configuration due to: ${reply.errorMsg}`));
    }
    return Promise.resolve(reply.configuration);
  }

  public async requestConfiguration(query: GroupConfigurationRequest): Promise<DownlinkItem[] | Error> {
    const reply = await curCoreClient.requestGroupConfiguration(query);
    if (reply.errorMsg) {
      return Promise.reject(new Error(`Cannot request group configuration due to: ${reply.errorMsg}`));
    }
    return Promise.resolve(reply.queue);
  }

  public async sendGroupCommand(query: GroupDeviceCommandReq): Promise<DownlinkItem[] | Error> {
    const reply = await curCoreClient.sendGroupCommand(query);
    if(reply.errorMsg) {
      return Promise.reject(new Error(`Cannot send a device command: ${reply.errorMsg}`));
    }
    return Promise.resolve(reply.queue);
  }

  public async sendConfiguration(query: GroupDeviceCommandReq): Promise<DownlinkItem[] | Error> {
    const reply = await curCoreClient.sendGroupCommand(query);
    if(reply.errorMsg) {
      return Promise.reject(new Error(`Cannot send group configuration: ${reply.errorMsg}`));
    }
    return Promise.resolve(reply.queue);
  }

  public async fetchDownlinksQueue(query: GroupConfigurationQuery): Promise<DownlinkItem[] | Error> {
    const reply = await curCoreClient.fetchGroupDownlinkQueue(query);
    if(reply.errorMsg) {
      return Promise.reject(new Error(`Cannot fetch group downlinks due to: ${reply.errorMsg}`));
    }
    return Promise.resolve(reply.queue);
  }

  public canConfigureDevices(deviceList:Device[]):boolean {
    const allOfNeededType = _.every(deviceList, (device) => {
      return device.deviceType === 'abeewaySmartBadge'
        || device.deviceType === 'nsenMk2'
        || device.deviceType === 'nsenSubstation'
        || device.deviceType === 'nsenGofield'
        || device.deviceType === 'nsenWeatherStation'
        || device.deviceType === 'nsenPrv'
        || device.deviceType === 'nsenVac'
    });
    const commonGroups = this.commonGroup(deviceList);
    return allOfNeededType && commonGroups.length > 0 && deviceList.length <= 100;
  }

  commonGroup(deviceList:Device[]):string[] {
    const allGroups = _.map(deviceList, device => device.groupIdList);
    const commonGroups = _.filter(_.intersection(...allGroups), group => !group.endsWith('.master'));
    return commonGroups;
  }
}

export interface GroupConfigurationQuery {
  groupId: string;
}

export interface GroupConfigurationParameter {
  id: number;
  label: string;
  value: number | string;
}

export interface GroupConfigurationRequest {
  groupId: string;
  params?: number[];
}

export interface GroupDeviceCommandReq {
  groupId: string;
  command: string;
  params?: DeviceCommandParams[];
  updateConfiguration?: boolean;
}

export const curGroupService = new GroupService();
